import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { t } from "i18next";
import React from "react";

interface ConfirmationDialogProps {
  title: string;
  content: string;
  onClose: (isConfirmed: boolean) => void;
  isOpen: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  content,
  onClose,
  isOpen,
}) => {
  const handleClose = ({ isConfirmed }) => {
    onClose(isConfirmed);
  };

  return (
    <Dialog open={isOpen} onClose={() => handleClose({ isConfirmed: false })}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => handleClose({ isConfirmed: false })}
          autoFocus
        >
          {t("common.cancel")}
        </Button>
        <Button
          variant="outlined"
          onClick={() => handleClose({ isConfirmed: true })}
        >
          {t("common.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
